import {useEffect, useState} from "react";
import {useAuth} from "react-oidc-context";
import {CompaniesTable} from "../components/CompaniesTable";
import {Company} from "../entities/company";
import {useNavigate} from "react-router-dom";

export const MyCompaniesPage = () => {

    const auth = useAuth();
    const navigate = useNavigate();
    const [companies, setCompanies] = useState([])
    useEffect(() => {
        if (!auth.isAuthenticated) {
            return;
        }
        const token = auth.user?.access_token
        fetch("/api/companies", {headers: {"Authorization": `Bearer ${token}`}}).then(
            res => res.json()
        ).then(json => {
            setCompanies(json)
        })
    }, [auth.isAuthenticated, auth.user?.access_token]);

    const onCompanyClick = (company:Company) => {
        navigate(`./${company.id}`)
    }

    return (<CompaniesTable onCompanyClick={onCompanyClick} companies={companies} showTokenCount={false}></CompaniesTable>)
}